import React from "react";
import Layout from "../../components/Layout";
import StudentCategoryList from "../../components/StudentCategoryList";
import { Helmet } from "react-helmet";

export default () => {
  const title = "Movement Category | Student Resources";
  const description =
    "Here are some ideas on ways to move your body, refresh your mind, and build your skills.";
  return (
    <Layout>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
      </Helmet>
      <section className="section">
        <div className="container">
          <div className="content">
            <h1 className="title">Movement</h1>
            <p>{description}</p>
            <StudentCategoryList category="movement" />
          </div>
        </div>
      </section>
    </Layout>
  );
};
